import { PUBLIC_STORAGE_URL } from '@/constants/global'

export const LME_STATE_DOCS = {
  ES: PUBLIC_STORAGE_URL + '/lme/ES.zip',
  GO: PUBLIC_STORAGE_URL + '/lme/GO.zip',
  MG: PUBLIC_STORAGE_URL + '/lme/MG.zip',
  MS: PUBLIC_STORAGE_URL + '/lme/MS.zip',
  PE: PUBLIC_STORAGE_URL + '/lme/PE.zip',
  PR: PUBLIC_STORAGE_URL + '/lme/PR.zip',
  RJ: PUBLIC_STORAGE_URL + '/lme/RJ.zip',
  RS: PUBLIC_STORAGE_URL + '/lme/RS.zip',
  SC: PUBLIC_STORAGE_URL + '/lme/SC.zip',
  SP: PUBLIC_STORAGE_URL + '/lme/SP.zip',
}
